import * as React from 'react';
import { ArticleParagraph1, Label } from '@cian/ui-kit';
import * as styles from './styles.css';
import icon from './assets/Icon.svg';

export const MobileDailyRentBanner: React.FC = () => {
  return (
    <div className={styles['banner']}>
      <div className={styles['title']}>
        <Label background="primary_100" color="white">
          Новое
        </Label>

        <ArticleParagraph1>Добавили оценку дохода от посуточной аренды</ArticleParagraph1>
      </div>

      <div className={styles['icon']}>
        <img src={icon} />
      </div>
    </div>
  );
};
